var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"gift",attrs:{"src":require("../../../../assets/image/live/gift.png")},on:{"click":_vm.showgift}})}
var staticRenderFns = []

export { render, staticRenderFns }